import { store } from "../redux/store";
import axios from "../helper/axiosIntance";

class Headers {
  static setHeaders = () => {
    axios.defaults.headers.common[
      "Authorization"
    ] = store.getState().auth.token;
  };
}

export default Headers;
